// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qaqc-dialog-content {
    min-width: 480px;
    max-height: 70vh;
    overflow: auto;
    padding: 2px 24px !important;
    background-color: #f0f0f0;
}

.content {
    padding: 16px;
    border-radius: 4px;
}

.pick-buttons {
    display: flex;
    gap: 8px;
    justify-content: center;
    margin-top: 14px;
    padding-bottom: 4px;
}

.qaqc-dialog-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    background-color: #f0f0f0;
    padding: 8px 24px !important;
}

.qaqc-dialog-actions .button {
    width: auto !important;
    flex: none;
}

.qaqc-title {
    font-size: 14px;
    line-height: 22px;
}

.reading-name {
    font-size: 14px;
    line-height: 1.4;
    word-break: break-word;
}

.reading-temp {
    gap: 6px;
    flex-shrink: 0;
}

.temp-input {
    width: 60px;
    height: 28px;
    text-align: center;
    padding: 2px 4px;
}

.title-input {
    width: 100%;
    height: 28px;
    padding: 2px 6px;
}

.scd-delete-icon {
    color: #c0392b;
    font-weight: bold;
    cursor: pointer;
    font-size: 1rem;
    line-height: 1;
    margin-top: 4px;
    margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/manage-qaqc-readings/manage-qaqc-readings.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".qaqc-dialog-content {\n    min-width: 480px;\n    max-height: 70vh;\n    overflow: auto;\n    padding: 2px 24px !important;\n    background-color: #f0f0f0;\n}\n\n.content {\n    padding: 16px;\n    border-radius: 4px;\n}\n\n.pick-buttons {\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n    margin-top: 14px;\n    padding-bottom: 4px;\n}\n\n.qaqc-dialog-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    background-color: #f0f0f0;\n    padding: 8px 24px !important;\n}\n\n.qaqc-dialog-actions .button {\n    width: auto !important;\n    flex: none;\n}\n\n.qaqc-title {\n    font-size: 14px;\n    line-height: 22px;\n}\n\n.reading-name {\n    font-size: 14px;\n    line-height: 1.4;\n    word-break: break-word;\n}\n\n.reading-temp {\n    gap: 6px;\n    flex-shrink: 0;\n}\n\n.temp-input {\n    width: 60px;\n    height: 28px;\n    text-align: center;\n    padding: 2px 4px;\n}\n\n.title-input {\n    width: 100%;\n    height: 28px;\n    padding: 2px 6px;\n}\n\n.scd-delete-icon {\n    color: #c0392b;\n    font-weight: bold;\n    cursor: pointer;\n    font-size: 1rem;\n    line-height: 1;\n    margin-top: 4px;\n    margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
